export default {
  familyName: 'Source Sans 3',
  fullName: 'Source Sans 3 Regular',
  postscriptName: 'SourceSans3-Regular',
  category: 'sans-serif',
  capHeight: 660,
  ascent: 1024,
  descent: -400,
  lineGap: 0,
  unitsPerEm: 1000,
  xHeight: 486,
  xWidthAvg: 418,
  subsets: {
    latin: {
      xWidthAvg: 418
    },
    thai: {
      xWidthAvg: 653
    }
  }
};
